import React, { useState } from 'react';
import { useLayout } from './AppLayout';
import FormModal from '../Components/ui/FormModal';
import RequirementForm from '../Components/RequirementForm';
import AdminCreateUser from '../Components/AdminCreateUser';
import CreateClient from '../Components/CreateClient';
import UpdateUser from '../Components/UpdateUser';
import AdminUpdateClient from '../Components/AdminUpdateClient';
import UserActions from '../Components/UserActions';
import { showSuccess } from '../utils/toast';

const FORM_MODALS = {
  'create-requirement': {
    title: 'Add Requirement',
    component: RequirementForm,
    componentProps: { mode: 'admin' },
    formId: 'admin-add-requirement-form',
    size: 'xxl',
  },
  'create-user': {
    title: 'Create User',
    component: AdminCreateUser,
    formId: 'admin-create-user-form',
    size: 'lg',
  },
  'edit-user': {
    title: 'Edit User',
    component: UpdateUser,
    formId: 'edit-user-form',
    size: 'lg',
  },
  'create-client': {
    title: 'Create Client',
    component: CreateClient,
    formId: 'create-client-form',
    size: 'xl',
  },
  'edit-client': {
    title: 'Edit Client',
    component: AdminUpdateClient,
    formId: 'edit-client-form',
    size: 'xl',
  },
  'create-tl-requirement': {
    title: 'Add Requirement',
    component: RequirementForm,
    componentProps: { mode: 'teamlead' },
    formId: 'tl-add-requirement-form',
    size: 'xxl',
  },
  'upload-candidate': {
    title: 'Upload Source Profile',
    component: UserActions,
    formId: 'upload-candidate-form',
    size: 'xxl',
    saveLabel: 'Upload',
  },
};

function FormModalHost() {
  const { activeFormModal, modalPayload, closeFormModal, handleFormSuccess } = useLayout();
  const [saveDisabled, setSaveDisabled] = useState(false);

  if (!activeFormModal || !FORM_MODALS[activeFormModal]) return null;

  const { title, component: FormComponent, componentProps, formId, size, saveLabel } = FORM_MODALS[activeFormModal];

  const onSuccess = (message) => {
    showSuccess(message || 'Saved successfully');
    handleFormSuccess(message);
  };

  const isUploadCandidate = activeFormModal === 'upload-candidate';

  return (
    <FormModal
      show
      title={title}
      onHide={closeFormModal}
      formId={formId}
      size={size}
      saveLabel={saveLabel}
      saveDisabled={isUploadCandidate ? saveDisabled : false}
    >
      <FormComponent
        embedded
        onClose={closeFormModal}
        onSuccess={onSuccess}
        onSubmitReadyChange={isUploadCandidate ? setSaveDisabled : undefined}
        modalPayload={modalPayload}
        {...(componentProps || {})}
      />
    </FormModal>
  );
}

export default FormModalHost;
